<template>
    <header>
        <img :src="require('./assets/bg-header-desktop.svg')" alt="" />
    </header>
    <div class="job-listing-container">
        <job-listing
            v-for="jobListing of jobListings"
            :jobListing="jobListing"
            :key="jobListing.company"
        ></job-listing>
    </div>
</template>

<script>
import JobListing from '@/components/JobListing.vue'

export default {
    components: {
        JobListing,
    },
    data() {
        return {
            jobListings: [
                {
                    jobTitle: 'Senior Frontend Developer',
                    imagePath: 'photosnap.svg',
                    company: 'Photosnap',
                    new: true,
                    featured: true,
                    tags: ['Frontend', 'Senior', 'HTML', 'CSS', 'JavaScript'],
                    longAgo: '1d',
                    jobType: 'Full Time',
                    location: 'USA only',
                },
                {
                    jobTitle: 'Fullstack Developer',
                    imagePath: 'manage.svg',
                    company: 'Manage',
                    new: true,
                    featured: true,
                    tags: ['Fullstack', 'Midweight', 'Python', 'React'],
                    longAgo: '1d',
                    jobType: 'Part Time',
                    location: 'Remote',
                },
                {
                    jobTitle: 'Junior Frontend Developer',
                    imagePath: 'account.svg',
                    company: 'Account',
                    new: true,
                    featured: false,
                    tags: ['Frontend', 'Junior', 'React', 'Sass', 'Javascript'],
                    longAgo: '2d',
                    jobType: 'Part Time',
                    location: 'USA only',
                },
                {
                    jobTitle: 'Junior Frontend Developer',
                    imagePath: 'myhome.svg',
                    company: 'MyHome',
                    new: false,
                    featured: false,
                    tags: ['Frontend', 'Junior', 'CSS', 'Javascript'],
                    longAgo: '5d',
                    jobType: 'Contract',
                    location: 'USA only',
                },
                {
                    jobTitle: 'Software Engineer',
                    imagePath: 'loop-studios.svg',
                    company: 'Loop Studios',
                    new: false,
                    featured: false,
                    tags: [
                        'Fullstack',
                        'Midweight',
                        'Javascript',
                        'Sass',
                        'Ruby',
                    ],
                    longAgo: '1w ago',
                    jobType: 'Full Time',
                    location: 'World Wide',
                },
                {
                    jobTitle: 'Junior Backend Developer',
                    imagePath: 'faceit.svg',
                    company: 'FaceIt',
                    new: false,
                    featured: false,
                    tags: ['Backend', 'Junior', 'Ruby', 'RoR'],
                    longAgo: '2w',
                    jobType: 'Full Time',
                    location: 'UK only',
                },
                {
                    jobTitle: 'Junior Developer',
                    imagePath: 'shortly.svg',
                    company: 'Shortly',
                    new: false,
                    featured: false,
                    tags: ['Frontend', 'Junior', 'HTML', 'Sass', 'Javascript'],
                    longAgo: '2w ago',
                    jobType: 'Full Time',
                    location: 'Worldwide',
                },
                {
                    jobTitle: 'Junior Frontend Developer',
                    imagePath: 'insure.svg',
                    company: 'Insure',
                    new: false,
                    featured: false,
                    tags: ['Frontend', 'Junior', 'Vue', 'Sass', 'Javascript'],
                    longAgo: '2w ago',
                    jobType: 'Full Time',
                    location: 'USA only',
                },
                {
                    jobTitle: 'Full Stack Engineer',
                    imagePath: 'eyecam-co.svg',
                    company: 'Eyecam Co.',
                    new: false,
                    featured: false,
                    tags: [
                        'Fullstack',
                        'Midweight',
                        'Django',
                        'Python',
                        'Javascript',
                    ],
                    longAgo: '3w ago',
                    jobType: 'Full Time',
                    location: 'Worldwide',
                },
                {
                    jobTitle: 'Front-end Dev',
                    imagePath: 'the-air-filter-company.svg',
                    company: 'The Air Filter Company',
                    new: false,
                    featured: false,
                    tags: ['Frontend', 'Junior', 'React', 'Sass', 'Javascript'],
                    longAgo: '1mo ago',
                    jobType: 'Part Time',
                    location: 'Worldwide',
                },
            ],
        }
    },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Spartan:wght@100;300;400;700&display=swap');
:root {
    --color-primary: hsl(180, 29%, 50%);
    --color-background: hsl(180, 52%, 96%);
    --color-filterTablets: hsl(180, 31%, 95%);
    --color-darker-gray-cyan: hsl(180, 14%, 20%);
    --color-dark-gray-cyan: hsl(180, 8%, 52%);
}

html {
    font-size: 62.5%;
}

* {
    box-sizing: border-box;
    margin: 0;
}

body {
    font-family: 'Spartan', sans-serif;
    background: var(--color-background);
}

header {
    margin: 0;
    width: 100vw;
    height: 10rem;
    background: var(--color-primary);
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
}

.job-listing-container {
    width: 80rem;
    margin: 0 auto;
    @media (max-width: 1000px) {
        width: 90%;
    }
}
</style>
